import { Box, Card, Typography } from '@mui/material';
import ErrorOutline from '@mui/icons-material/ErrorOutline';

const ServiceUnavailable = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: { xs: '50vh', sm: '60vh' },
        p: { xs: 1, sm: 2 },
      }}
    >
      <Card
        sx={{
          border: '1px solid #D9D9D9',
          boxShadow: 'none',
          p: { xs: 2, sm: 4 },
          borderRadius: 3,
          textAlign: 'center',
          maxWidth: { xs: '100%', sm: 400 },
          width: '100%',
          mx: { xs: 1, sm: 0 },
        }}
      >
        <Box sx={{ mb: { xs: 2, sm: 3 } }}>
          <ErrorOutline
            sx={{
              fontSize: { xs: 48, sm: 60 },
              color: '#ff9800',
              mb: { xs: 1, sm: 2 },
            }}
          />
        </Box>
        <Typography
          variant='h5'
          sx={{
            fontWeight: 600,
            mb: { xs: 1.5, sm: 2 },
            color: '#333',
            fontSize: { xs: '1.25rem', sm: '1.5rem' },
          }}
        >
          Service Temporarily Unavailable
        </Typography>
        <Typography
          variant='body1'
          sx={{
            color: '#666',
            lineHeight: 1.6,
            mb: 1,
            fontSize: { xs: '0.9rem', sm: '1rem' },
          }}
        >
          Sorry for the inconvenience, please come back next week.
        </Typography>
        <Typography
          variant='body2'
          sx={{
            color: '#999',
            fontSize: { xs: '0.8rem', sm: '0.875rem' },
          }}
        >
          We're working to resolve this issue as quickly as possible.
        </Typography>
      </Card>
    </Box>
  );
};

export default ServiceUnavailable;
